import { render } from "./BaseOverlayHeader.vue?vue&type=template&id=7b2df69a&scoped=true"
import script from "./BaseOverlayHeader.vue?vue&type=script&lang=js"
export * from "./BaseOverlayHeader.vue?vue&type=script&lang=js"

import "./BaseOverlayHeader.vue?vue&type=style&index=0&id=7b2df69a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2df69a"]])

export default __exports__